import React from 'react'
import OverlayWrapper from './OverlayWrapper'
import { ErrorMessage, Field, Formik } from 'formik'
import FieldWrapper from '../../forms/FieldWrapper'
import Translation from '../../Translation/cont/Translation'
import OverlaySubmitCancelButtons from './OverlaySubmitCancelButtons'


const OverlayForm = ({
    className='',
    initValues,
    inputOptions,
    editDisabled,
    onClose,
    onSubmitValues
}) => (
    <OverlayWrapper>
        <div className={"overlay-form" + (className ? ' '  + className : '')}>
            <Formik
                initialValues={initValues}
                // validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    if(editDisabled) {
                        return false
                    }

                    onSubmitValues(values)
                    actions.setSubmitting(false);
                    onClose()
                }}
            >
                {({handleSubmit}) => (
                    <form onSubmit={handleSubmit}> 
                        <fieldset>
                            <div className="left-sections">
                                {inputOptions.map(({id, type, transId}) => (
                                    'text' === type ? ( 
                                        <FieldWrapper key={id} label={<Translation id={transId} />} id={id} classes="field-text">
                                            <Field type="text" name={id} id={id} className="text-regular input-text-box" />
                                            <ErrorMessage name={id} component="div" /> 
                                        </FieldWrapper>
                                    ) : ''
                                ))}
                            </div>

                            <OverlaySubmitCancelButtons
                                editDisabled={editDisabled}
                                onClose={onClose}
                            />
                        </fieldset>
                    </form>
                )}
            </Formik>
        </div>
    </OverlayWrapper>
)

export default OverlayForm